export const queue = () => (
  <path
    d="M21 10H3m18-4H3m8 8H5a2 2 0 100 4h16m0 0l-3-3m3 3l-3 3"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
